import { AdriverEventData } from './adriver';
import { AstraLabEvent } from './astraLab';
import { RoxotEvent } from './roxot';
import { SolowayPixelData } from './soloway';
import { WcmConversionId, WcmConversionIdAlias } from './weborama';

export type PixelEventName =
    | 'B2B_ALL_SITE'
    | 'B2B_PROMO_PAGE_SHOWN'
    | 'B2B_EMPLOYER_PAGE_SHOWN'
    | 'B2B_EMPLOYER_AUTHORIZATION'
    | 'B2B_EMPLOYER_REGISTRATION'
    | 'B2B_PROMO_PAGE_SEARCH'
    | 'B2B_EMPLOYER_PAGE_SEARCH'
    | 'B2B_RESUME_OPEN_FROM_PROMO_PAGE'
    | 'B2B_VACANCY_COMPLETE'
    | 'B2C_ALL_SITE'
    | 'B2C_MAIN_PAGE_SHOWN'
    | 'B2C_APPLICANT_AUTHORIZATION'
    | 'B2C_APPLICANT_REGISTRATION'
    | 'B2C_APPLICANT_REGISTRATION_THIRD_PARTY'
    | 'B2C_MAIN_PAGE_SEARCH'
    | 'B2C_VACANCY_RESPONSE_CLICK'
    | 'B2C_VACANCY_RESPONSE_COMPLETE'
    | 'B2C_RESUME_COMPLETE'
    | 'B2C_RESUME_UPDATE'
    | 'B2C_VACANCY_SEARCH_PAGE_SHOWN'
    | 'EMPLOYER_REGISTRATION_SHOWN'
    | 'ZP_ALL_SITE'
    | 'ZP_ADD_WISHLIST'
    | 'ZP_VIEW_PRODUCT'
    | 'ZP_PURCHASE'
    | 'ZP_CALL'
    | 'ZP_B2B_ALL_SITE'
    | 'ZP_B2B_POST_VACANCY'
    | 'ZP_B2B_SEARCH_RESUME'
    | 'ZP_B2B_REGISTRATION';

type PixelHandlers = {
    weborama?: WcmConversionId[];
    soloway?: SolowayPixelData;
    astraLab?: AstraLabEvent;
    adriver?: AdriverEventData;
    roxot?: RoxotEvent;
    // old_wcm_start
    marcom?: true;
    // old_wcm_end
};

export const PixelEventsMap: Record<PixelEventName, PixelHandlers> = {
    B2B_ALL_SITE: {
        roxot: {
            eventCode: '24272921-582f-4baf-9dbc-63a7736ba138',
            isHead: true,
        },
    },
    B2B_PROMO_PAGE_SHOWN: {
        weborama: [WcmConversionIdAlias.HH_B2B_PAGE, WcmConversionIdAlias.HH_B2B_PAGE_RU],
    },
    B2B_EMPLOYER_PAGE_SHOWN: {},
    B2B_EMPLOYER_AUTHORIZATION: {
        weborama: [
            WcmConversionIdAlias.HH_AUTHORIZATION_EMPLOYER,
            WcmConversionIdAlias.HH_B2B_AUTHORIZATION_EMPLOYER_RU,
        ],
    },
    B2B_EMPLOYER_REGISTRATION: {
        weborama: [WcmConversionIdAlias.HH_REGISTRATION_CLIENT, WcmConversionIdAlias.HH_B2B_REGISTRATION_CLIENT_RU],
        roxot: {
            eventCode: 'fcef19fe-8919-4e34-9905-bc77e5780263',
        },
    },
    B2B_PROMO_PAGE_SEARCH: {},
    B2B_EMPLOYER_PAGE_SEARCH: {},
    B2B_RESUME_OPEN_FROM_PROMO_PAGE: {},
    B2B_VACANCY_COMPLETE: {},
    B2C_ALL_SITE: {
        weborama: [WcmConversionIdAlias.HH_ALL_SITE, WcmConversionIdAlias.HH_B2B_ALL_SITE_RU],
    },
    B2C_MAIN_PAGE_SHOWN: {},
    B2C_APPLICANT_AUTHORIZATION: {
        weborama: [
            WcmConversionIdAlias.HH_AUTHORIZATION_SOISKATEL,
            WcmConversionIdAlias.HH_B2C_AUTHORIZATION_SOISKATEL_RU,
        ],
    },
    B2C_APPLICANT_REGISTRATION: {
        weborama: [
            WcmConversionIdAlias.HH_REGISTRATION_SOISKATEL,
            WcmConversionIdAlias.HH_B2C_REGISTRATION_SOISKATEL_RU,
            WcmConversionIdAlias.HH_B2C_REGISTRATION_SOISKATEL_2_RU,
        ],
        roxot: {
            eventCode: '9494716d-88fb-4172-8f23-f3d6483dc115',
        },
        marcom: true,
    },
    B2C_APPLICANT_REGISTRATION_THIRD_PARTY: {
        weborama: [WcmConversionIdAlias.HH_B2C_REGISTRATION_SOISKATEL_2_RU],
        marcom: true,
    },
    B2C_MAIN_PAGE_SEARCH: {},
    B2C_VACANCY_RESPONSE_CLICK: {
        weborama: [
            WcmConversionIdAlias.HH_B2C_CO_BRAND_START_OTCLICK,
            WcmConversionIdAlias.HH_B2C_CO_BRAND_START_OTCLICK_RU,
        ],
        roxot: {
            eventCode: 'ef37a103-83a2-4111-a25d-dcb734743645',
        },
    },
    B2C_VACANCY_RESPONSE_COMPLETE: {
        weborama: [WcmConversionIdAlias.HH_B2C_SUCCESS_OTCLICK, WcmConversionIdAlias.HH_B2C_SUCCESS_OTCLICK_RANDOM_RU],
        roxot: {
            eventCode: 'beacb077-8baa-445a-95b9-7896e19a8717',
        },
    },
    B2C_VACANCY_SEARCH_PAGE_SHOWN: {
        weborama: [
            WcmConversionIdAlias.HH_B2C_CLICK_NAITI_RABOTU,
            WcmConversionIdAlias.HH_B2C_CLICK_NAITI_RABOTU_RANDOM_RU,
        ],
    },
    B2C_RESUME_UPDATE: {
        weborama: [WcmConversionIdAlias.HH_B2C_UPDT_RESUME, WcmConversionIdAlias.HH_B2C_UPDT_RESUME_RANDOM_RU],
    },
    B2C_RESUME_COMPLETE: {},
    EMPLOYER_REGISTRATION_SHOWN: {
        roxot: {
            eventCode: 'be5dab86-4b88-4e6f-9722-c9690e67b89d',
        },
    },
    ZP_ALL_SITE: {},
    ZP_ADD_WISHLIST: {},
    ZP_VIEW_PRODUCT: {},
    ZP_PURCHASE: {},
    ZP_CALL: {},
    ZP_B2B_ALL_SITE: {},
    ZP_B2B_POST_VACANCY: {},
    ZP_B2B_SEARCH_RESUME: {},
    ZP_B2B_REGISTRATION: {},
};
